export const MENU_ITEMS = [
  {
    key: 'home',
    label: 'Home',
    description: 'Show the hero section and the Home link.',
  },
  {
    key: 'about',
    label: 'About',
    description: 'Show the About section and its menu link.',
  },
  {
    key: 'products',
    label: 'Products',
    description: 'Show the Products section and its menu link.',
  },
  {
    key: 'news',
    label: 'News',
    description: 'Show the homepage news block and News page links.',
  },
  {
    key: 'contact',
    label: 'Contact',
    description: 'Show the Contact section and contact menu links.',
  },
];

export const DEFAULT_MENU_CONFIG = {
  home: { enabled: true },
  about: { enabled: true },
  products: { enabled: true },
  news: { enabled: true },
  contact: { enabled: true },
};

export function getMenuConfig(menu) {
  return MENU_ITEMS.reduce((config, item) => {
    config[item.key] = {
      ...DEFAULT_MENU_CONFIG[item.key],
      ...(menu?.[item.key] || {}),
    };
    return config;
  }, {});
}

export function isMenuItemEnabled(menu, key) {
  return getMenuConfig(menu)[key]?.enabled !== false;
}
